var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdp-drawer", attrs: { "content-type": _vm.contentType } },
    [
      _c("h3", { staticClass: "pdp-drawer__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "pdp-drawer__body",
        domProps: {
          innerHTML: _vm._s(_vm.content.replace("<p>&nbsp;</p>", ""))
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }